import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './global.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { CartProvider } from "./AllComponents/CartContext"; // Cart context
import store from './AllComponents/LoginRedux';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <CartProvider> {/* Wrap App with CartProvider */}
          <App />
          <ToastContainer 
            position="top-right"
            autoClose={3000}
            theme="colored" 
          />
        </CartProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
